import _ from 'lodash';

import { getBaseAssetUrl } from 'common/dist/utils/url';
import { ChatConversation } from '../common';

import * as api from '../api';

const NON_DOCTOR_SUFFIX_SET = new Set<string>(
  Object.values(api.User.OtherSuffixMap),
);

export const INVERTED_LANGUAGE_MAP = _.invert(api.Language.languageMap);

export function getProviderCards(
  message: ChatConversation,
  limit: number = 3,
): {
  providers: api.User.UserWithProfileAndPreference[] | undefined;
  total: number;
} {
  if (
    'recommendedProviders' in message &&
    message.recommendedProviders?.length
  ) {
    return {
      providers: message.recommendedProviders
        .filter(
          (
            recommendedProvider,
          ): recommendedProvider is api.User.UserWithProfileAndPreference =>
            'firstName' in recommendedProvider,
        )
        .slice(0, limit),
      total: message.recommendedProviders.length,
    };
  }
  if ('hacks' in message && message.hacks?.providers?.length) {
    return {
      providers: message.hacks.providers,
      total: message.hacks.providers.length,
    };
  }
  return { providers: undefined, total: 0 };
}

export function getPrevisitAsset(assetUrl: string) {
  if (assetUrl.startsWith('http')) return assetUrl;
  return assetUrl ? `${getBaseAssetUrl()}/${encodeURIComponent(assetUrl)}` : '';
}

export function getProviderNameFull(args: {
  provider: Pick<
    api.User.SafeProvider,
    'firstName' | 'middleName' | 'lastName' | 'prefix' | 'suffix'
  >;
  onlyFullName?: boolean;
}): string {
  const { provider, onlyFullName = false } = args;
  const { firstName, middleName, lastName, prefix, suffix } = provider;
  const fullName = [firstName, middleName, lastName]
    .filter((x) => !!x)
    .join(' ');
  if (onlyFullName || !fullName) return fullName;

  const providerSuffix = suffix ? `, ${suffix}` : '';
  if (!suffix || NON_DOCTOR_SUFFIX_SET.has(suffix.toUpperCase())) {
    const providerPrefix = prefix
      ? prefix.endsWith('.')
        ? `${prefix} `
        : `${prefix}. `
      : '';
    return `${providerPrefix}${fullName}${providerSuffix}`;
  }
  return `${fullName}${providerSuffix}`;
}

export function constructAddress(
  practice: Pick<Partial<api.Address.Address>, 'address' | 'city' | 'zip'> & {
    state?: string | null;
  },
): string {
  let result = '';
  const { address, city, state, zip } = practice;
  if (address) result += address;
  if (city) result += result.length ? ', ' + city : city;
  if (state) result += result.length ? ', ' + state : state;
  if (zip) result += result.length ? ' ' + zip : zip;
  return result.trim();
}
